import { useEffect, useState } from "react";
import { Moon, Sun } from "lucide-react";

export default function ThemeToggle({ dark = false }) {
  const [isDark, setIsDark] = useState(
    () => localStorage.getItem("hm-theme") === "dark"
  );

  useEffect(() => {
    document.documentElement.classList.toggle("dark", isDark);
    localStorage.setItem("hm-theme", isDark ? "dark" : "light");
  }, [isDark]);

  const base =
    "flex h-8 w-8 items-center justify-center rounded-full transition-colors duration-300";
  const cls = dark
    ? `${base} text-base/70 hover:bg-base/10 hover:text-base`
    : `${base} border border-ink/15 text-ink/60 hover:border-ink hover:bg-gold hover:text-base`;

  return (
    <button
      onClick={() => setIsDark(!isDark)}
      data-testid="theme-toggle"
      aria-label={isDark ? "Comută pe tema luminoasă" : "Comută pe tema întunecată"}
      className={cls}
    >
      {isDark ? <Sun className="h-4 w-4" /> : <Moon className="h-4 w-4" />}
    </button>
  );
}
